import { render, staticRenderFns } from "./NumberOfDeliveries.vue?vue&type=template&id=7b5ba64c&"
import script from "./NumberOfDeliveries.vue?vue&type=script&lang=js&"
export * from "./NumberOfDeliveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports